'use strict';

var _    = require('underscore');
var $    = require('jquery');
var Core = require('../core/core.js');

/**
 * Creates a Submenu Tool
 *
 * @class
 */

class ToolbarOffsetTool extends Core {

    _defaults() {
        return {
            target: '.js-editor',
            fields: {
                'name': '0',
                'description': '0',
                'icon': false
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <div class='editor__tab__toolbar__offsettool'>
                <a class='btn btn--m btn--background_base_borders js-editor__tab__toolbar__tool' title='<%- description %>'>
                    <div class='btn__icon cio-ui-icon'><%= embedded_svg(icon) %></div>
                    <div class='btn__txt'><%- name %></div>
                </a>
            </div>
        `;

        super.render();

        /**
         * Click event
         *
         * @fires ToolbarOffsetTool#_clicked
         */

        $('.js-editor__tab__toolbar__tool', this.$el).on('click', this._clicked);
    }

    /**
     * @event ToolbarOffsetTool#Cioui:ToolbarOffsetTool:clicked
     * @property {String}Cioui:ToolbarOffsetTool:clicked
     * @returns {Object} event - native click Event
     */

    _clicked(e){
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:ToolbarOffsetTool:clicked', e);
    }

    /**
     * Makes the tool button active
     */

    setActive(){
        $('.js-editor__tab__toolbar__tool', this.$el).addClass('active');
    }

    /**
     * Makes the tool button inactive
     */

    setInActive(){
        $('.js-editor__tab__toolbar__tool', this.$el).removeClass('active');
    }
}
module.exports = ToolbarOffsetTool;